import { Outlet } from "react-router-dom"
import Header from '../layout/Header'

const Layout = ({children}) => {
    return (
        <>
        <Header/> 
        <div className="main">
           {children}
        </div>
        </>
    )
}

export default Layout
